jQuery(function($){
	'use strict';

	var bannerTexts = [
		'You are browsing our services available in (19013).',
		'You are browsing our services available in ({{ZIP}}).',
		'Your zipcode ({{ZIP}}) is not in our coverage area.',
	];

	var $banner = $('#services-bar');
	var $bannerText = $('span', $banner);
	var $dialogOpenBtn = $('a', $banner);
	var $bannerHideBtn = $('button', $banner);
	var $dialog = $('#pul-dialog');
	var $progress = $('<span>Updating <svg style="margin-left:10px" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_I8Q1{animation:spinner_qhi1 .75s linear infinite}.spinner_vrS7{animation-delay:-.375s}@keyframes spinner_qhi1{0%,100%{r:1.5px}50%{r:3px}}</style><circle class="spinner_I8Q1" cx="4" cy="12" r="1.5"/><circle class="spinner_I8Q1 spinner_vrS7" cx="12" cy="12" r="3"/><circle class="spinner_I8Q1" cx="20" cy="12" r="1.5"/></svg></span>');

	var $acfLocationText = $('.location-banner p span');
	var manualUpdate = false;

	getLocation();

	$bannerHideBtn.click(function(){ $banner.hide(); });
	$dialogOpenBtn.click(function(){ $dialog.show(); return false; });

	$(document).on('click', '.location-banner p span', function(e){
		e.preventDefault();
		e.stopPropagation();
		$dialog.show();
	});

	$(document).on('click', '#pul-dialog-wrap .pul-cancel', function(){ $dialog.hide(); });

	$(document).on('submit', '#pul-dialog-wrap form', function(){
		var $this = $(this);
		var $zipcode = $('.zip-code-field', $this);
		var zc = $.trim($zipcode.val());

		if (zc) {
			if (!isValidZipCode(zc)){
				var input = $zipcode[0];
				var errmsg = 'Please enter a valid zip code e.g. 00601';
				if (input.setCustomValidity && input.reportValidity){
					input.setCustomValidity(errmsg);
					input.reportValidity();
				} else {
					alert(errmsg);
				}
			} else {
				manualUpdate = true;
				var $submitBtn = $('.pul-submit', $this);
				$submitBtn.html($progress.html()).prop('disabled',true);
				var $cancelBtn = $('.pul-cancel', $this);
				$cancelBtn.prop('disabled',true);

				$acfLocationText.html(zc);

				getTerritory(zc, 'manual', function(){
					$submitBtn.html('Update').prop('disabled',false);
					$cancelBtn.prop('disabled',false);
					$dialog.hide();
				});
			}
		}
		return false;
	});

	$(document).on('change', '#pul-dialog-wrap form .zip-code-field', function(){
		if (this.setCustomValidity) this.setCustomValidity('');
	});

	$(document).on('click', function(e){
		if (0 === $(e.target).closest('#pul-dialog form').length) $dialog.hide();
	});

	$(document).on('keyup', function(e){
		if ('Escape' === e.key) $dialog.hide();
	});

	function getTerritory(zip, source, onSuccess, onComplete){
		var data = { action: 'pul_get_territory', nonce: powerUserLocation.nonce };
		if (zip) data.zip = zip;

		var reportErrors = 'manual' === source;

		$.ajax({
			url: powerUserLocation.ajaxurl,
			data: data,
			type: 'POST',
			cache: false,
			success: function (response) {
				if (manualUpdate && 'manual' !== source) {
					return;
				}

				if (!response.success) {
					if (reportErrors) {
						$bannerText.html('Error occurred while determining our coverage area (' + response.data + ').');
					}
					return;
				}

				var data = response.data;
				var msg;

				if ('no territory' === data.message) {
					msg = bannerTexts[2].replace('{{ZIP}}', zip || data.zip_code);

					setCookie('user_zc1_loc', '', -1);
					setCookie('user_zc1_full_loc', '', -1);
				}

				else if ('success' === data.message) {
					msg = bannerTexts[1].replace('{{ZIP}}', data.zip_code);

					setCookie('user_zc1_loc', data.abbreviation, 365);
					setCookie('user_zc1_full_loc', data.territory, 365);

					if (!manualUpdate && $acfLocationText.length) {
						$acfLocationText.html(data.zip_code);
					}
				}
				else {
					msg = bannerTexts[0];
				}

				setCookie('user_location_source', source, 365);
				$bannerText.html(msg);

				if (data.zip_code) setCookie('user_zc1', data.zip_code, 365);
				setCookie('user_zc1_status', data.message, 365);
				setCookie('user_zc', '', -1);
				setCookie('user_zc_status', '', -1);

				$(document).trigger('user_zc_changed', [data]);
				if (onSuccess) onSuccess(data);
			},
			error: function(xhr, err){
				if (reportErrors) {
					$bannerText.html('AJAX error occurred (' + formatErrorMessage(xhr,err) + ').');
				}
			},
			complete:function(xhr,status){
				if (manualUpdate && 'manual' !== source) {
					return;
				}
				if (onComplete) onComplete(xhr,status);
			}
		});
	}

	function getLocation(){
		var zc = getCookie('user_zc1');
		var msg = getCookie('user_zc1_status');
		var locationSource = getCookie('user_location_source');

		if (zc && msg && isValidZipCode(zc) && ('success' === msg || 'no territory' === msg)) {
			var i = 'success' === msg ? 1 : 2;
			$bannerText.html(bannerTexts[i].replace('{{ZIP}}', zc));

			if ($acfLocationText.length) {
				$acfLocationText.html(zc);
				if (locationSource === 'manual') manualUpdate = true;
			}
			return;
		}

		// No zip is sent: server uses Cloudflare postal code, then 19013.
		getTerritory(undefined, 'cf');
	}

	function isValidZipCode(zipCode){
		return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
	}

	function setCookie(name, value, days){
		var cookie = name + '=' + value;
		if (days) cookie += '; max-age=' + days * 86400;
		cookie += '; path=/; SameSite=Strict';
		document.cookie = cookie;
	}

	function getCookie(name){
		var value = '; ' + document.cookie;
		var parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	function formatErrorMessage(jqXHR, exception){
		if (jqXHR.status === 0) return 'Not connected.\nPlease verify your network connection';
		else if (jqXHR.status == 404) return 'The requested page not found [404]';
		else if (jqXHR.status == 500) return 'Internal Server Error [500]';
		else if (exception === 'parsererror') return 'Requested JSON parse failed';
		else if (exception === 'timeout') return 'Time out error';
		else if (exception === 'abort') return 'Ajax request aborted';
		else return 'Uncaught Error:\n' + jqXHR.responseText;
	}
});
